/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import { BackendUser } from '../../types';

interface SearchProps {
  users: Array<BackendUser>;
  onChange: (user: BackendUser) => void;
}

export default function Search({ users, onChange }: SearchProps) {
  const [searchText, setSearchText] = React.useState('');
  const [results, setResults] = React.useState<BackendUser[]>([]);

  const search = (v: string) => {
    const searchResults = users.filter((u) => (`${u.first_name} ${u.last_name}`.toLowerCase().startsWith(v.toLowerCase())));
    setResults(searchResults);
  };

  const handleOnChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
    setSearchText(evt.target.value);
    search(evt.target.value);
  };

  const handleUserSelect = (id: string) => () => {
    setResults([]);
    setSearchText('');
    onChange(users.find((u) => (u.id === id)));
  };

  return (
    <div className="recognition-search">
      <div className="recognition-search-inputgroup">
        <label htmlFor="name">Name</label>
        <input type="text" name="name" value={searchText} onChange={handleOnChange} autoComplete="off" />
      </div>
      {
        results && results.length > 0 && (
          <div className="recognition-search-results">
            <ul>
              {
                results.map((r) => (
                  <li key={r.id} onClick={handleUserSelect(r.id)}>{`${r.first_name} ${r.last_name}`}</li>
                ))
              }
            </ul>
          </div>
        )
      }
    </div>
  );
}
